import { HeaderCellWithId } from "types/business/HeaderCellWithId";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = HeaderCellWithId[];

export const useDefaultObservableHeaderCellWithIdArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectHeaderCellWithIdArray extends BehaviorSubject<CurrentType> {}
